import React from 'react';
import Header from './Header';
import Date from './Date';
import Creator from './Creator';
import Participation from './Participation';
import classNames from 'classnames';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import Partners from '../Row/Partners';
import Notes from '../Row/Notes';
import StatusTags from '../Row/StatusTags';
import Bookmark from '../../_components/Bookmark';
import { useConnect } from '../../../../hooks/@lore/query-connect';
import Activity from './Activity';
import Cost from '../Row/Cost';
import DateRange from '../../../dialogs_new/offer_manage/Header/DateRange';
import Organization from '../Row/Organization';
import { useUser } from '@lore/auth';
import Network from './Network';

export default function Offer(props) {
  const { offer, className, children } = props;

  const activity = useConnect('tag.byId', {
    id: offer.data.activityId
  });

  const currentUser = useUser();

  const launch = useDialogLauncher();

  function onClick() {
    if (props.onClick) {
      props.onClick();
    } else {
      launch(DialogManager.OfferManage.Config(offer.id));
    }
  }

  return (
    <div className={classNames(
      'flex flex-col bg-white',
      'shadow-cs-flat rounded-cs-10',
      '-m-0.5 border-2 border-cs-gray-100',
      'relative overflow-hidden',
      // 'hover:bg-cs-orange-50 cursor-pointer',
      className
    )}>
      {/*<Link to={`/offers/${offer.id}`} className="absolute w-full h-full" />*/}
      <div className="absolute z-10 top-4 right-4 pt-0.5x pr-0.5x">
        <Bookmark
          type="offer"
          resource={offer}
        />
      </div>
      <div className="flex flex-col py-4 px-4 space-y-2 hover:bg-cs-orange-50 cursor-pointer" onClick={onClick}>
        {/*<div className="flex space-x-2 min-h-5">*/}
        {/*  /!*<Activity activity={activity} />*!/*/}
        {/*  <StatusTags offer={offer} />*/}
        {/*</div>*/}
        <StatusTags offer={offer} />
        <div className="pr-10">
          <Header offer={offer} />
        </div>
        <div className="flex flex-col sm:flex-row items-start justify-between">
          <div className="flex flex-1 flex-wrap gap-x-4 gap-y-2 mb-2 sm:mb-0">
            <DateRange offer={offer} />
            <Creator offer={offer} />
            <Organization offer={offer} />
            <Cost offer={offer} />
            {currentUser.data.isStaff && (
              <Network offer={offer} />
            )}
          </div>
          <Partners offer={offer} />
        </div>
      </div>
      {/*{false && (*/}
      {/*  <div className={classNames(*/}
      {/*    'w-full py-4 px-4',*/}
      {/*    'bg-cs-gray-50',*/}
      {/*    '-mt-px border-t border-cs-gray-100',*/}
      {/*  )}>*/}
      {/*    <Participation offer={offer} />*/}
      {/*  </div>*/}
      {/*)}*/}
      {/*<Participation offer={offer} />*/}
      {children}
      <div className="bg-gray-50 p-4">
        <Notes offer={offer}/>
      </div>
    </div>
  );
}
